import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=bd2b98b0&"
import script from "./popover.vue?vue&type=script&lang=js&"
export * from "./popover.vue?vue&type=script&lang=js&"
import style0 from "./popover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports